import React from "react"

// Вкладки страницы настроек в общем стиле .tabs: tabs — [{ key, label }],
// пустые элементы (false/null) пропускаются, чтобы вкладку можно было скрыть условием
function PageTabs({ tabs, active, onChange, className = 'mb-3' }) {
	return (
		<div className={`tabs tabs-sm ${className}`}>
			<ul>
				{tabs.filter(Boolean).map(tab => (
					<li key={tab.key}
						className={active === tab.key ? 'active' : ''}
						onClick={() => onChange(tab.key)}>
						<span className="link">{tab.label}</span>
					</li>
				))}
			</ul>
		</div>
	)
}

export default PageTabs
